<div
  class="vertical-field"
  [attr.data-disabled]="disabled"
  [attr.data-error]="error"
>
  <!-- Label -->
  @if (label) {
    <div class="vertical-field-label">
      <umss-label
        [text]="label"
        [htmlFor]="htmlFor"
        [required]="required"
        [disabled]="disabled"
        [error]="error"
        layout="Block"
        size="Regular"
        weight="Medium"
      >
      </umss-label>
    </div>
  }

  <!-- Content (form control via ng-content) -->
  <div class="vertical-field-content">
    <ng-content></ng-content>
  </div>

  <!-- Helper Text -->
  @if (helperText && !error) {
    <p class="vertical-field-helper">{{ helperText }}</p>
  }

  <!-- Error Message -->
  @if (error && errorMessage) {
    <p class="vertical-field-error">{{ errorMessage }}</p>
  }
</div>
